<template>
  <div class="cart-entry">
    <div class="table-cell hidden-ipad col-2">
      <img :src="item.cover|defaultCover"
           width="170"
           height="96"
           :alt="item.subject">
    </div>
    <div class="table-cell col-3"
         style="padding-left: 32px;">
      <div class="strong hidden-xs">
        <a class="text-ellipse"
           href="javascript:;">{{ item.subject }}</a>
      </div>
      <div class="strong visible-xs">
        <a href="javascript:;">{{ item.subject }}</a>
      </div>
      <div class="visible-xs">
        <span :class="{duration: item.duration&&item.duration.time}">
          {{ item.duration&& item.duration.date }} {{ item.duration&&item.duration.time }}
        </span>
        <span class="chapters">| 共{{ item.chapters.length }}节</span>
      </div>
      <div class="teacher">授课老师：{{ item.teachers }}</div>
      <div v-if="item.materials &&item.materials.length"
           class="ziliao entry-ziliao">
        <span><i class="fa fa-zeng"></i>&nbsp;&nbsp;教材&福利*{{ item.materialsCount }}</span>
      </div>
    </div>
    <div class="table-cell col-5 hidden-xs"
         style="padding-left: 32px;">
      <div>
        <span :class="{duration: !(item.duration&&item.duration.time)}">
          {{ item.duration&& item.duration.date }}
        </span>
        <span :class="{duration: item.duration&&item.duration.time}">
          {{ item.duration&&item.duration.time }}
        </span>
        <span class="chapters">| 共 {{ item.chapters.length }} 节</span>
      </div>
    </div>
    <!-- price -->
    <div class="table-cell col-2  cart-price-box"
         style="padding-left: 32px;">
      <slot v-if="isGroup">
        <div class="visible-xs">
          <span class="origin-price delete-price">￥{{ Number((item.price/100).toFixed(2)) }}</span>
          <span class="group-price">￥{{ Number((item.left_group_price/100).toFixed(2)) }}</span>
          <span class="badge">团购价</span>
        </div>
        <div class="hidden-xs">
          <div class="origin-price delete-price">{{ Number((item.price/100).toFixed(2)) }}</div>
          <div class="group-price">￥{{ Number((item.left_group_price/100).toFixed(2)) }}</div>
          <div class="badge">团购价</div>
        </div>
      </slot>
      <div v-else
           class="price-wrapper"
           :style="item.couponPrice ? 'text-align: right;':''">
        <div v-if="item.deletedPrice&&item.deletedPrice!==item.needPrice"
             style="margin-bottom:7px;">
          <span class="origin-price delete-price">￥{{ Number((item.deletedPrice/100).toFixed(2)) }}</span>
          <span v-if="item.left_sub_count && item.left_sub_count !== item.chapters.length"
                class="badge badge-warning">剩余{{ item.left_sub_count }}章节</span>
        </div>
        <span class="active-price">￥{{ Number((item.needPrice/100).toFixed(2)) }}</span>
        <div v-if="item.isUnion"
             style="margin-top:7px;">
          <span class="badge union-price-tag"
                style="width:40px;padding:3px;">联报价</span>
        </div>
      </div>
      <div style="clear:both;
      text-align:right;">
        <span style="
      padding:2px;
      font-size: 12px;
      background: rgba(198, 205, 218, 0.3);
      color: rgba(51, 51, 51, 0.5);
      border-radius: 2px;"
              v-if="item.material_goods_id>0">含{{(item.material_goods_price)}}元教材费</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    isGroup: Boolean,
    item: Object
  },
  filters: {
    defaultCover (src) {
      return src || process.env.VUE_APP_IMAGE_DEFAULT_ORIGIN + '/img/live/default-cover.png'
    }
  }
}
</script>
